import config from '@config';

export default (state = config, action = {}) => state;
